import React, { PureComponent } from 'react'
import { string, bool, func } from 'prop-types'
import Modal from '@active/react-ui/Modal'
import ModalBody from '@active/react-ui/ModalBody'
import ModalFooter from '@active/react-ui/ModalFooter'
import WaiverContent from '../../../common/WaiverContent'

class ReagreeWaiver extends PureComponent {
  static propTypes = {
    selectedCountryCode: string,
    isReagreeWaiverShow: bool.isRequired,
    isForceRequireAction: bool,
    handleReagreeWaiverClose: func.isRequired,
    handleReagreeWaiverSubmit: func.isRequired,
    handleBack: func.isRequired,
    isBack: bool.isRequired,
    showReagreeWaiverError: bool,
    resetAgrees: bool.isRequired,
    handleReagreeWaiverCheckboxChange: func.isRequired,
  }

  static defaultProps = {
    selectedCountryCode: undefined,
    showReagreeWaiverError: false,
    isForceRequireAction: false,
  }

  onClose = () => {
    const { isForceRequireAction, handleReagreeWaiverClose } = this.props
    if (!isForceRequireAction) {
      handleReagreeWaiverClose()
    }
  }

  render() {
    const {
      isReagreeWaiverShow,
      ...rest
    } = this.props

    return (
      <Modal
        autoFocusClose
        onClose={this.onClose}
        shown={isReagreeWaiverShow}
        className="passport-ui-app__modal passport__signin__reagreeWaiver-popup action_required"
      >
        <WaiverContent
          isSignin
          isRequired
          {...rest}
          Body={ModalBody}
          Footer={ModalFooter}
        />
      </Modal>
    )
  }
}

export default ReagreeWaiver
